import React from 'react';
import './style.scss';

export interface JUNOButtonProps {
  onClick?: () => void;
  href?: string;
  buttonStyle: string;
  textStyle?: string;
  id?: string;
  buttonIcon?: string;
  text: string;
  buttonType?: string;
  tabIndex?: number;
}

const JUNOButton: React.FC<JUNOButtonProps> = ({
  onClick = () => {},
  buttonStyle,
  buttonIcon,
  buttonType,
  href,
  id,
  text,
  textStyle,
  ...props
}) => {
  if (href) {
    return (
      <a role="button" onClick={onClick} className={buttonStyle} id={id} href={href} {...props}>
        {text}
      </a>
    );
  } else {
    return (
      <div role="button" onClick={onClick} className={buttonStyle} id={id} tabIndex={0} {...props}>
        {buttonIcon && (
          <span className={`juno_button_icon`}>
            <i className={buttonIcon}></i>
          </span>
        )}
        <div className={textStyle || 'juno_button_text'}>{text}</div>
      </div>
    );
  }
};

export default JUNOButton;
